<template>
    <div class="flex items-center justify-between " @click="open">
        <span class="flex justify-center items-center w-6 h-6 md:w-8 md:h-8 icon-chevron_sinistra cursor-pointer border border-next-dark-gray hover:bg-next-orange hover:text-white hover:border-next-orange" @click.prevent.stop="back"></span>
        <span class="relative text-sm md:text-base select-none cursor-pointer">{{ weekStart.format('LL')  }} - {{ weekEnd.format('LL') }}
            <input class="absolute inset-0 invisible" ref="input" type="week" @change="dateChange" :value="Value">
        </span>
        <span class="flex justify-center items-center w-6 h-6 md:w-8 md:h-8 icon-chevron_destra cursor-pointer border border-next-dark-gray hover:bg-next-orange hover:text-white hover:border-next-orange" @click.prevent.stop="forward"></span>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import moment from "moment/moment";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";

@Options({
    name: 'WeekSwitcher',
    components: {},
    props: {
        date: String,
    }
})
export default class WeekSwitcher extends Vue {
    currentDate:any = null
    weekStart:any = null
    weekEnd:any = null
    date!:any

    supportWeeks = true

    initDate(date?:moment.Moment| string){
        moment.locale('it')
        if(date instanceof moment || (typeof date == "string" && date.length)){
            this.currentDate = moment(date)
        } else {
            this.currentDate = moment()
        }
        this.weekStart = this.currentDate.clone().startOf('week');
        this.weekEnd = this.currentDate.clone().endOf('week');
    }

    created(){
        moment.locale('it')
        this.initDate(this.date)
        this.emitUpdate()
    }

    mounted(){
        (this.$refs.input as HTMLInputElement).type = 'week';
        // if it does, run the code inside the if() {} block
        if((this.$refs.input as HTMLInputElement).type === 'text') {
            (this.$refs.input as HTMLInputElement).type = 'date';
            this.supportWeeks = false
        }
    }

    @Watch('date')
    dataUpdate($new:string, $old:string) {
        this.initDate($new)
    }

    open(){
        try {
            //@ts-ignore
            this.$refs.input.showPicker()
        } catch (error) {
        }
    }

    get Value(){
        if(this.supportWeeks){
            return this.currentDate.format('YYYY-[W]WW')
        }
        return this.currentDate.format('YYYY-MM-DD')
    }

    dateChange($event:any){
        this.initDate($event.target.value)
        this.emitUpdate()
    }

    back(){
        this.initDate(this.currentDate.subtract(1, 'week'))
        this.emitUpdate()
    }

    forward(){
        this.initDate(this.currentDate.add(1, 'week'))
        this.emitUpdate()
    }

    emitUpdate(){
        this.$emit('update:date', this.currentDate.format('YYYY-MM-DD'))
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
